import { useState, useEffect, useRef } from 'react';
import { subscribe } from '../../../services/utils/pubsub';
import { ComponentEvents } from '../../../services/wss/events/ComponentEvents';
import yourDataEngine from './YourDataEngine';

// Filter — only handle dataChanged events from YourDataEngine
const isDataEvent = (e) => e.name === 'YourDataEngine' && e.target === 'dataChanged';

/**
 * Painter hook for YourDataEngine.
 * Subscribes to engine notifications and exposes read-only state.
 * All mutations go through yourDataEngine directly.
 */
export default function useYourData() {
    const mounted = useRef(false);
    // Read current engine state on mount — prevents flash of empty ContentPanel on tab switch
    const [entries, setEntries] = useState(() => yourDataEngine.getEntries());
    const [selectedTopic, setSelectedTopic] = useState(() => yourDataEngine.getSelectedTopic());
    const [selectedEntry, setSelectedEntry] = useState(() => yourDataEngine.getSelectedEntry());
    const [total, setTotal] = useState(() => yourDataEngine.getTotal());
    const [currentPage, setCurrentPage] = useState(() => yourDataEngine.getCurrentPage());

    const handleEvent = (e) => {
        if (!isDataEvent(e)) return;
        if (!mounted.current) return;

        setEntries(e.data.entries);
        setSelectedTopic(e.data.selectedTopic);
        setSelectedEntry(e.data.selectedEntry);
        setTotal(e.data.total);
        setCurrentPage(e.data.currentPage);
    };

    useEffect(() => {
        mounted.current = true;
        const unsub = subscribe(ComponentEvents.channel, handleEvent);
        return () => {
            mounted.current = false;
            unsub();
        };
    }, []);

    return {
        entries,
        selectedTopic,
        selectedEntry,
        total,
        currentPage,

        // Pass-through action — loads a specific page for the active topic.
        loadPage: (page) => yourDataEngine.loadPage(page),
    };
}
